import { revalidatePath } from "@/lib/revalidate";

import { ApiError, uploadCsv } from "@/lib/api/client";
import type { CsvReport } from "@/lib/api/types";

export type ImportResult = { ok: true; report: CsvReport } | { ok: false; error: string };

/** Validate (commit=false) or import (commit=true) a CSV file. The BFF decides
 * everything; this only translates transport failures into a displayable shape. */
export async function importCsvAction(
  sport: string,
  master: string,
  csv: string,
  commit: boolean,
): Promise<ImportResult> {
  try {
    const report = await uploadCsv(sport, master, csv, commit);
    if (commit && report.committed) revalidatePath(`/${sport}/masters/${master}`);
    return { ok: true, report };
  } catch (error) {
    const message = error instanceof ApiError ? error.message : "Unexpected error importing.";
    return { ok: false, error: message };
  }
}
